import { createContext, useContext } from "react";

/**
 * Opens the patient side peek from anywhere in the 2026 shell. Neo replies
 * render tagged patient names as links; clicking one calls ``openPatient``.
 * Surfaces outside the provider (legacy pages) get ``null`` and keep plain
 * names. Kept free of the peek itself so every chat message can read it
 * without loading the drawer (and its charts); see ``PatientPeekProvider``.
 */
export interface PatientPeekTarget {
  /** ``clinic_patient.id`` (the ``p-<id>`` in Neo's name tags). */
  patientId: number;
  /** Name as written in the chat, shown until the profile loads. */
  name?: string;
}

export interface PatientPeekContextValue {
  openPatient: (target: PatientPeekTarget) => void;
}

export const PatientPeekContext = createContext<PatientPeekContextValue | null>(
  null
);

export const usePatientPeek = () => useContext(PatientPeekContext);
